// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1axbU","content":"styles_content__3HDR5","checkbox":"styles_checkbox__37UhX","checkboxLabel":"styles_checkboxLabel__35bUF"};